import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import DetailsBtn from './_Components/DetailsBtn';
import ResendModal from './_Components/ResendModal';
import AddUserModal from './_Components/AddUserModal';
import ActivateModal from './_Components/ActivateModal';
import InactivateModal from '../_Components/InactivateModal';
import SearchComponent from './_Components/SearchComponent';
import RenderProfilePicture from '../../../../_helpers/profile-picture';

import { alertActions } from '../../../../_actions/alert.actions';
import { usersService } from '../../../../_services/users.service';

export default function ListUsers({ history }) {
  const { path } = useRouteMatch();
  const dispatch = useDispatch()

  const usersOnline = useSelector(state => state.client.usersOnline);

  const [page, setPage] = useState(1)
  const [viewType, setViewType] = useState('all');
  const [user, setUser] = useState()
  const [users, setUsers] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [showResendModal, setShowResendModal] = useState(false)
  const [showAddUserModal, setShowAddUserModal] = useState(false)
  const [showActivateModal, setShowActivateModal] = useState(false)
  const [showInactivateModal, setShowInactivateModal] = useState(false)

  const [dataTotal, setDataTotal] = useState(0);

  useEffect(() => {
    setIsLoading(true)

    const {page, search, type, status, roleId} = queryString.parse(history.location.search);

    usersService.retrieveUsers({page, search, type, status, roleId})
      .then(response => {
        setUsers(response.data)
        setDataTotal(response.meta.total);
      })
      .catch(() => {
        dispatch(alertActions.error('Could not retrieve users at this time. Please try again.'));
      })
      .then(() => {
        setIsLoading(false)
      })
  }, [dispatch, history.location.search])

  useEffect(() => {
    let { page } = queryString.parse(history.location.search);

    if (!page) {
      page = 1
    }

    setPage(parseInt(page))

  }, [history.location.search])

  const handleDetailsClick = (type, user) => {
    switch (type) {
      case 'resend':
        setShowResendModal(true)
        break;
      case 'revoke':
        setShowInactivateModal(true)
        break;
      case 'activate':
        setShowActivateModal(true)
        break;
      case 'details':
        history.push(`${path}/${user.userId}`)
        break;
      default:
        break;
    }
  }

  const columns = [
    {
      name: 'STATUS',
      width: '150px',
      sort: false,
      cell: user => {
        switch(user.status) {
          case 'Active':
            return <span style={{opacity: '0.7', width: '60px'}} className="badge badge-success py-2">Active</span>
          case 'Pending':
            return <span style={{opacity: '0.7', width: '60px'}} className="badge badge-warning text-light py-2">Pending</span>
          case 'Inactive':
            return <span style={{opacity: '0.7', width: '60px'}} className="badge badge-danger py-2">Inactive</span>
          default: 
            return null
        }
      }
    },
    {
      name: 'USER',
      sort: false,
      cell: (user) => {
        let lastName = user.lastName

        if (user.credentials) {
          lastName = `${lastName}, ${user.credentials}`
        }

        return <div className='row w-100'>
        <div className="col-2">
          <RenderProfilePicture height={30} width={30} image={user.profileUrl} circle cached={false} className='m-auto' />
        </div>
        <div className="col-auto">
          <div className="row">
            <div className="col">
              <div>{`${user.firstName} ${lastName}`}</div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span className='text-muted'>{user.specialtyTitle}</span>
            </div>
          </div>
        </div>
      </div>
      }
    },
    {
      name: '',
      sort: false,
      cell: (user) => {
        return <span className='text-muted'>{user.email}</span>
      }
    },
    {
      button: true,
      sort: false,
      width: '150px',
      cell: user => {
        return <DetailsBtn status={user.status} handleClick={(action) => {
          setUser(user)
          handleDetailsClick(action, user)
        }}/>
      }
    }
  ];

  const reloadData = () => {
    const {page, search, type, status} = queryString.parse(history.location.search);

    usersService.retrieveUsers({page, search, type, status})
      .then(response => {
        setUsers(response.data)
        setDataTotal(response.meta.total);
      })
      .catch(() => {
        dispatch(alertActions.error('Could not retrieve users at this time. Please try again.'));
      })
      .then(() => {
        setIsLoading(false)
      })
  }

  return (
    <>
      <header className='mb-4 d-flex justify-content-between'>
        <div className='lead pt-2'>Users&nbsp;
          { usersOnline.length > 0 &&
            <span className="badge badge-pill badge-secondary" style={{cursor: 'pointer'}} onClick={() => {
                setViewType(viewType === 'all' ? 'online' : 'all')
              }}>{ viewType === 'all' ? `${usersOnline.length} Online` : 'View All' }
            </span>        
          }
        </div>

        <div onClick={() => setShowAddUserModal(true)} className="btn btn-success">
            <i className="fas fa-plus fa-xs"></i> &nbsp;Add User
        </div>
      </header>

      <ResendModal 
        user={user}
        show={showResendModal}
        handleClose={() => setShowResendModal(false)}
      />

      <InactivateModal 
        user={user}
        show={showInactivateModal}
        handleClose={(reload) => {
          setShowInactivateModal(false)
          if (reload) {
            reloadData();
          }
        }}
      />

      <ActivateModal 
        user={user}
        show={showActivateModal}
        handleClose={(reload) => {
          setShowActivateModal(false)
          if (reload) {
            reloadData();
          }
        }}
      />

      <AddUserModal
        show={showAddUserModal}
        handleClose={() => setShowAddUserModal(false)}
      />

      <div className="axs-shadow axs-rounded p-1" style={{background: 'white'}}>
        { viewType === 'online' &&
          <DataTable
            noHeader
            columns={columns}
            data={usersOnline}
            pagination={false}
            customStyles={{ 
              cells: { style: { fontSize: '14px', padding: '1.5em' }, }, 
              headCells: { style: { fontWeight: 400, color: 'RGB(161, 165, 183)', padding: '1.5em'}, }, 
              subHeader: { style: { justifyContent: 'space-between', padding: '10px 10px 0 10px' } }
            }}
          /> 
        }

        { viewType === 'all' &&
          <DataTable
            noHeader
            columns={columns}
            data={users}
            progressPending={isLoading}
            subHeader
            subHeaderComponent={<SearchComponent history={history} />}
            onChangePage={page => {
              const { ...searchParams } = queryString.parse(history.location.search)

              searchParams.page = page;
              
              history.replace(`/account/users?${queryString.stringify(searchParams)}`)
            }}
            pagination={true}
            paginationServer={true}
            paginationDefaultPage={page}
            paginationTotalRows={dataTotal}
            paginationRowsPerPageOptions={[15]}
            paginationPerPage={15}
            customStyles={{ 
              cells: { style: { fontSize: '14px', padding: '1.5em' }, }, 
              headCells: { style: { fontWeight: 400, color: 'RGB(161, 165, 183)', padding: '1.5em'}, }, 
              subHeader: { style: { justifyContent: 'space-between', padding: '10px 10px 0 10px' } }
            }}
          />        
        }
      </div>
    </>
  )
}
